import useActivationObject from '../../../providers/ActivationObjectProvider/hooks/useActivationObject'
import { Step1Props, useStep1Props } from '../types'
import useStep1FileHandling from './useStep1.fileHandle'
import useStep1Form from './useStep1.form'
import useStep1FormConditions from './useStep1.form.conditions'
import useStep1FormOptions from './useStep1.form.options'

const useStep1 = (props: useStep1Props): Step1Props => {
    const { data: activationObject, isUpdating } = useActivationObject()
    const formProps = useStep1Form(activationObject)
    const optionsProps = useStep1FormOptions(formProps.form)
    const conditionsProps = useStep1FormConditions(formProps.form, optionsProps, activationObject)
    const useFileHandleProps = useStep1FileHandling(formProps.form)

    return {
        activationObject,
        form: formProps,
        file: useFileHandleProps,
        options: optionsProps,
        conditions: conditionsProps,
        isUpdating,
    }
}

export default useStep1
